import { Button, Col, Form, Input, Row } from "antd";

const InventoryReceptionComment = ({ onComplete }) => {
	const [form] = Form.useForm();

	const onFinish = (values) => {
		const comment = values.comment;
		form.resetFields();
		onComplete(comment);
	};

	const CustomForm = () => {
		return (
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item label="Comment" name="comment">
							<Input.TextArea size="large" />
						</Form.Item>
					</Col>
				</Row>

				<Button type="primary" htmlType="submit" size="large">
					Send
				</Button>
			</Form>
		);
	};

	return <CustomForm />;
};

export default InventoryReceptionComment;
